module.exports = __webpack_public_path__ + "img/9.844521e8.png";